module.exports = __webpack_public_path__ + "static/media/cailogo.803bda97.png";